import React from 'react';
import notFound404 from '../../assets/images/error404.jpg';

const NotFound404 = () => (
  <div>
    <img style={{ width: '100%', height: '100%' }} src={notFound404} alt="" />
  </div>
);
export default NotFound404;



// WEBPACK FOOTER //
// ./src/components/NotFound404/index.js